import { render } from "./OrderMobileActionsFooter.vue?vue&type=template&id=4e20d740&scoped=true&ts=true"
import script from "./OrderMobileActionsFooter.vue?vue&type=script&lang=ts"
export * from "./OrderMobileActionsFooter.vue?vue&type=script&lang=ts"

import "./OrderMobileActionsFooter.vue?vue&type=style&index=0&id=4e20d740&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e20d740"]])

export default __exports__